import { LangLanguageEnum } from '../generated/api/enumLib_api';

export const possibleLanguages = [
  'Ar',
  'De',
  'Da',
  'En',
  'Es',
  'Fo',
  'Fr',
  'No',
  'Pl',
  'Ru',
  'Se',
] as const;

export type PossibleLangCode = (typeof possibleLanguages)[number];

export function isPossibleLangCode(code: unknown): code is PossibleLangCode {
  return (
    typeof code === 'string' &&
    possibleLanguages.includes(code as PossibleLangCode)
  );
}

export const fallback = (lang: PossibleLangCode): PossibleLangCode => {
  switch (lang) {
    case 'Fo':
    case 'Se':
    case 'No':
      return 'Da';
    default:
      return 'En';
  }
};

export const langLanguageEnumToPossibleLangCode = {
  [LangLanguageEnum.ar]: 'Ar',
  [LangLanguageEnum.da]: 'Da',
  [LangLanguageEnum.de]: 'De',
  [LangLanguageEnum.en]: 'En',
  [LangLanguageEnum.es]: 'Es',
  [LangLanguageEnum.fo]: 'Fo',
  [LangLanguageEnum.no]: 'No',
  [LangLanguageEnum.pl]: 'Pl',
  [LangLanguageEnum.ru]: 'Ru',
  [LangLanguageEnum.se]: 'Se',
  [LangLanguageEnum.fr]: 'Fr',
} as const satisfies Record<LangLanguageEnum, PossibleLangCode>;

export const possibleLangCodeToLangLanguageEnum = Object.fromEntries(
  Object.entries(langLanguageEnumToPossibleLangCode).map(([k, v]) => [v, k])
) as unknown as Record<PossibleLangCode, LangLanguageEnum>;

export type PossibleAppCode =
  | 'MyPlan'
  | 'TeamPlan'
  | 'FunctionPlan'
  | 'ClockPoint'
  | 'Shared';

export const possibleAppCodes: PossibleAppCode[] = [
  'MyPlan',
  'TeamPlan',
  'FunctionPlan',
  'ClockPoint',
  'Shared',
];
